import React from 'react'
import classnames from 'classnames';

import PropTypes from 'prop-types';
import { Input } from '../input'
import styles from './product-intent.module.scss';

export class ProductIntent extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange = (e) => {
        this.props.handleBPICheckboxChange(e.target.id, e.target.checked);
    }
    render() {
        return (
            <div className={classnames(styles.container, 'spark-shadow-tile', 'w-500px mx-auto mw-100')}>
            <h2 className={styles.title}>More about your deal</h2>
    
            <div className={styles.row}>
                <Input id={"tradeIn"} type="checkbox" checked={this.props.backendProductIntent.tradeIn} controlId="tradeIn" onChange={this.handleChange} />
                <label htmlFor="tradeIn">I have a trade-in</label>
            </div>
    
            <div className={styles.row}>
                <Input id={"accessories"} type="checkbox" checked={this.props.backendProductIntent.accessories} controlId="accessories" onChange={this.handleChange} />
                <label htmlFor="accessories">I’m interested in accessories</label>
            </div>
    
            <div className={styles.row}>
                <Input id={"insurance"} type="checkbox" checked={this.props.backendProductIntent.insurance} controlId="insurance" onChange={this.handleChange} />
                <label htmlFor="insurance">I’m considering insurance</label>
            </div>
    
            <div className={styles.row}>
                <Input id={"warranty"} type="checkbox" checked={this.props.backendProductIntent.warranty} controlId="warranty" onChange={this.handleChange} />
                <label htmlFor="warranty">I’m considering protection / warranty</label>
            </div>
    
            <div className={styles.row}>
                <Input id={"trailer"} type="checkbox" checked={this.props.backendProductIntent.trailer} controlId="trailer" onChange={this.handleChange} />
                <label htmlFor="trailer">I’ll need a trailer</label>
            </div>
            </div>
        )
    }
}

ProductIntent.propTypes = {
    backendProductIntent: PropTypes.object,
    handleBPICheckboxChange: PropTypes.func,
};